module.exports = __webpack_public_path__ + "images/link@3x-83fb3939.png";